import React, {
  Fragment,
  useContext,
  useEffect,
  useState,
  useRef,
} from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Autocomplete from "@mui/material/Autocomplete";
import { AlertContext } from "../../../context/AlertContext";
import { ServiciosContext } from "../../../context/ServiciosContext";
import { ConfiguracionContext } from "../../../context/ConfiguracionContext";
import { ThemeProvider, createMuiTheme } from "@mui/material/styles";
import { makeStyles } from "@mui/material/styles";
import Fab from "@mui/material/Fab";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import Spinner from "./../Spinner";
import { AuthContext } from "../../../context/AuthContext";
import { Checkbox } from "primereact/checkbox";
import { Button } from "primereact/button";
import { Tooltip } from "primereact/tooltip";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import "../../../assets/css/DataTableDemo.css";
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import { Tag } from "primereact/tag";
import { InputText } from "primereact/inputtext";
import ButtonMui from "@mui/material/Button";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import { Toast } from "primereact/toast";
import { Dialog } from "primereact/dialog";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import { saveAs } from "file-saver";
import Menu from "./../Menu";
import { InputNumber } from "primereact/inputnumber";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { InputMask } from "primereact/inputmask";
import IconButton from "@mui/material/IconButton";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";

const exportColumnsListado = [
  { title: "Fecha Comp.", dataKey: "FechaComprobante" },
  { title: "Fecha Cont.", dataKey: "FechaContabilizacion" },
  { title: "Comprobante", dataKey: "Comprobante" },
  { title: "Tipo", dataKey: "Tipo" },
  { title: "P.Venta", dataKey: "PuntoVenta" },
  { title: "Número", dataKey: "Numero" },
  { title: "Proveedor", dataKey: "NombreRazonSocial" },
  { title: "Condición", dataKey: "Condicion" },
  { title: "CUIT", dataKey: "Cuit" },
  { title: "Exento", dataKey: "Exento" },
  { title: "Neto", dataKey: "Neto" },
  { title: "Iva 10.5", dataKey: "Iva105" },
  { title: "Iva 21", dataKey: "Iva21" },
  { title: "Iva 27", dataKey: "Iva27" },
  { title: "Perc. IIBB Bs.As", dataKey: "PercBsas" },
  { title: "Perc. IIBB Caba", dataKey: "PercCaba" },
  { title: "Perc. I.V.A.", dataKey: "PercIva" },
  { title: "Perc. Gan.", dataKey: "PercGanancias" },
  { title: "Ret. I.V.A.", dataKey: "RetIva" },
  { title: "Ret. Gan.", dataKey: "RetGanancias" },
  { title: "Ret. IIBB", dataKey: "RetIIBB" },
  { title: "Otros Trib.", dataKey: "OtrosTributos" },
  { title: "Total", dataKey: "Total" },
];

const exportColumnsAgrupado = [
  { title: "Descripción", dataKey: "Descripcion" },
  { title: "Exento", dataKey: "Exento" },
  { title: "Neto", dataKey: "Neto" },
  { title: "Iva 10.5", dataKey: "Iva105" },
  { title: "Iva 21", dataKey: "Iva21" },
  { title: "Iva 27", dataKey: "Iva27" },
  { title: "Perc. IIBB Bs.As", dataKey: "PercBsAs" },
  { title: "Perc. IIBB Caba", dataKey: "PercCaba" },
  { title: "Perc. I.V.A.", dataKey: "PercIva" },
  { title: "Perc. Gan.", dataKey: "PercGanancias" },
  { title: "Ret. I.V.A.", dataKey: "RetIva" },
  { title: "Ret. Gan.", dataKey: "RetGanancias" },
  { title: "Ret. IIBB", dataKey: "RetIIBB" },
  { title: "Otros Trib.", dataKey: "OtrosTributos" },
  { title: "Total", dataKey: "Total" },
];

const agrupar = [
  {
    id: 1,
    nombre: "FechaContabilizacion",
  },
  {
    id: 2,
    nombre: "Comprobante",
  },
  {
    id: 3,
    nombre: "Proveedor",
  },
  {
    id: 4,
    nombre: "Condicion",
  },
];

export default function ListadosIvaCompras(props) {
  const [globalFilter, setGlobalFilter] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);

  const [visibleFechas, setVisibleFechas] = useState(true);
  const [fechas, setFechas] = useState(null);
  const [grupo, setGrupo] = useState(null);
  const [incluirAjustes, setIncluirAjustes] = useState(false);
  const [vigencia, guardarVigencia] = useState({
    desde: null,
    hasta: null,
  });
  const toast = useRef(null);
  const { tipo } = useParams();

  let navigate = useNavigate();

  //Context

  const alertContext = useContext(AlertContext);
  const { mensajeAlerta } = alertContext;

  const authContext = useContext(AuthContext);
  const { state, usuarioAutenticado } = authContext;

  const configuracionContext = useContext(ConfiguracionContext);
  const {
    statusAcceso,
    empresaElegida,
    listadoExcel,
    obtenerAcceso,
    obtenerIvaCompras,
  } = configuracionContext;

  useEffect(() => {
    if (state.usuario) {
      obtenerAcceso({
        usuarioId: state.usuario.id,
        layout: "ListadosIvaCompras",
      });
    }
  }, [state.id]);

  function formatDate(input) {
    var datePart = input.match(/\d+/g),
      year = datePart[0],
      month = datePart[1],
      day = datePart[2];
    return day + "/" + month + "/" + year;
  }

  const exitClick = (e) => {
    navigate("/");
  };

  const onHideFechas = (e) => {
    setVisibleFechas(false);
  };

  const aceptarFechas = async (exportType) => {
    //e.preventDefault();
    //Validar

    if (vigencia.desde === null) {
      if (tipo === "0") {
        mensajeAlerta(
          "Subdiario Iva Compras",
          "Debe indicar vigencia desde !.",
          "error"
        );
      } else {
        mensajeAlerta(
          "Listado de Compras",
          "Debe indicar vigencia desde !.",
          "error"
        );
      }
      return;
    }

    if (vigencia.hasta === null) {
      if (tipo === "0") {
        mensajeAlerta(
          "Subdiario Iva Compras",
          "Debe indicar vigencia hasta !.",
          "error"
        );
      } else {
        mensajeAlerta(
          "Listado de Compras",
          "Debe indicar vigencia hasta !.",
          "error"
        );
      }
      return;
    }

    let vig1 = null;
    let vig2 = null;
    if (vigencia.desde !== null && vigencia.hasta !== null) {
      vig1 = Number(
        vigencia.desde.substring(3, 5) + vigencia.desde.substring(0, 2)
      );
      vig2 = Number(
        vigencia.hasta.substring(3, 5) + vigencia.hasta.substring(0, 2)
      );
    }

    if (vig1 > vig2) {
      if (tipo === "0") {
        mensajeAlerta(
          "Subdiario Iva Compras",
          "Vigencia desde no puede ser mayor que vigencia hasta !.",
          "error"
        );
      } else {
        mensajeAlerta(
          "Listado de Compras",
          "Vigencia desde no puede ser mayor que vigencia hasta !.",
          "error"
        );
      }
      return;
    }

    var elem;

    toast.current.show({
      severity: "info",
      summary: "Listados",
      detail: "Obteniendo información... !",
      life: 3000,
    });

    await obtenerIvaCompras({
      vigencia,
      incluirAjustes: tipo === "0" ? false : true,
      grupo,
      empresaElegida,
      exportType,
    }).then((data) => {
      if (exportType === "excel") {
        elem = document.getElementById("expButtonExcel");
        elem.click();
      }
      if (exportType === "pdf") {
        elem = document.getElementById("expButtonPdf");
        elem.click();
      }
    });
    /*
    onHideFechas();
    setGrupo(null);
    guardarVigencia({
      desde: null,
      hasta: null,
    });
    setIncluyeIntegrantes(false);
    setTodasLasEmpresas(false);
    */
  };

  const accesoDenegado = () => {
    if (tipo === "0") {
      mensajeAlerta(
        "Subdiario Iva Compras",
        "No tiene permiso para acceder a esta pantalla !.",
        "error"
      );
    } else {
      mensajeAlerta(
        "Listado de Compras",
        "No tiene permiso para acceder a esta pantalla !.",
        "error"
      );
    }
    exitClick();
    return;
  };

  const renderHeaderFechas = () => {
    return (
      <div>
        <Tag
          value={
            empresaElegida && tipo === "0"
              ? "Subdiario Iva Compras " + empresaElegida.nombre
              : empresaElegida
              ? "Listado de Compras " + empresaElegida.nombre
              : null
          }
        ></Tag>
      </div>
    );
  };

  const renderFooterFechas = () => {
    return (
      <div>
        <button
          id="expButtonExcel"
          type="button"
          onClick={(e) => {
            exportExcel();
          }}
          style={{ visibility: "hidden" }}
        >
          Export Excel
        </button>
        <button
          id="expButtonPdf"
          type="button"
          onClick={(e) => {
            exportPdf();
          }}
          style={{ visibility: "hidden" }}
        >
          Export Pdf
        </button>

        <Button
          icon="pi pi-file-excel"
          onClick={(e) => {
            aceptarFechas("excel");
          }}
          className="p-button-raised p-button-success"
          data-pr-tooltip="XLS"
          label="Excel"
        />
        <Button
          icon="pi pi-file-pdf"
          onClick={(e) => {
            aceptarFechas("pdf");
            //exportPdf();
          }}
          className="p-button-raised p-button-warning"
          data-pr-tooltip="PDF"
          style={{ marginRight: "1em" }}
          label="PDF"
        />
        <ButtonMui
          onClick={onHideFechas}
          color="secondary"
          type="button"
          fullWidth
          variant="contained"
          startIcon={<CloseIcon />}
          autoFocus
        >
          Cancelar
        </ButtonMui>
      </div>
    );
  };

  const fechaTemplate = (rowData) => {
    return <Fragment>{formatDate(rowData.fecha)}</Fragment>;
  };

  const anuladoTemplate = (rowData) => {
    return (
      <Fragment>
        <Checkbox checked={rowData.anulado}></Checkbox>
      </Fragment>
    );
  };

  const exportExcel = () => {
        for (let i = 0; i < listadoExcel.length; i++) {
      listadoExcel[i].Exento = parseFloat(listadoExcel[i].Exento, 10);
      listadoExcel[i].Neto = parseFloat(listadoExcel[i].Neto, 10);
      //listadoExcel[i].neto105 = parseFloat(listadoExcel[i].neto105, 10);
      //listadoExcel[i].neto21 = parseFloat(listadoExcel[i].neto21, 10);
      //listadoExcel[i].neto27 = parseFloat(listadoExcel[i].neto27, 10);
      listadoExcel[i].Iva105 = parseFloat(listadoExcel[i].Iva105, 10);
      listadoExcel[i].Iva21 = parseFloat(listadoExcel[i].Iva21, 10);
      listadoExcel[i].Iva27 = parseFloat(listadoExcel[i].Iva27, 10);
      listadoExcel[i].PercBsAs = parseFloat(listadoExcel[i].PercBsAs, 10);
      listadoExcel[i].PercCaba = parseFloat(listadoExcel[i].PercCaba, 10);
      listadoExcel[i].PercIva = parseFloat(listadoExcel[i].PercIva, 10);
      listadoExcel[i].PercGanancias = parseFloat(listadoExcel[i].PercGanancias, 10);
      listadoExcel[i].RetIva = parseFloat(listadoExcel[i].RetIva, 10);
      listadoExcel[i].RetGanancias = parseFloat(listadoExcel[i].RetGanancias, 10);
      listadoExcel[i].RetIIBB = parseFloat(listadoExcel[i].RetIIBB, 10);
      listadoExcel[i].OtrosTributos = parseFloat(listadoExcel[i].OtrosTributos, 10);
      listadoExcel[i].Total = parseFloat(listadoExcel[i].Total, 10);
    }

    import("xlsx").then((xlsx) => {
      const worksheet = xlsx.utils.json_to_sheet(listadoExcel);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      if (tipo === "0") {
        saveAsExcelFile(excelBuffer, "subdiarioIvaCompras");
      } else {
        saveAsExcelFile(excelBuffer, "listadoCompras");
      }
    });
  };

  const saveAsExcelFile = (buffer, fileName) => {
    import("file-saver").then((FileSaver) => {
      let EXCEL_TYPE =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      let EXCEL_EXTENSION = ".xlsx";
      const data = new Blob([buffer], {
        type: EXCEL_TYPE,
      });
      return new Promise((resolve) => {
        saveAs(
          data,
          fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
        );
        resolve(true);
      });
    });
  };

  const exportPdf = () => {
    import("jspdf").then((jsPDF) => {
      import("jspdf-autotable").then(() => {
        if (!grupo || grupo === "") {
          //const doc = new jsPDF.default("l");
          const doc = new jsPDF.default('l', 'mm', 'legal');
          doc.setFontSize(10);
          if (tipo === "0") {
            doc.text(
              `Subdiario Iva Compras Desde: ${vigencia.desde} Hasta: ${vigencia.hasta}`,
              60,
              8
            );
          } else {
            doc.text(
              `Listado de Compras Desde: ${vigencia.desde} Hasta: ${vigencia.hasta}`,
              60,
              8
            );
          }

          doc.autoTable(exportColumnsListado, listadoExcel, {
            styles: {
              fontSize: 6,
            },
            columnStyles: {
              5: {
                halign: "right",
              },
              6: {
                halign: "right",
              },
              7: {
                halign: "right",
              },
              8: {
                halign: "right",
              },
              9: {
                halign: "right",
              },
              10: {
                halign: "right",
              },
              11: {
                halign: "right",
              },
            },
            didParseCell: (data) => {
              if (data.cell && data.cell.section === "head") {
                switch (data.cell.raw) {
                  case "Fecha":
                  case "Comprobante":
                  case "Afiliado":
                  case "Condición":
                  case "C.U.I.T./D.N.I.":
                    data.cell.styles.halign = "left";
                    break;
                  default:
                    data.cell.styles.halign = "right";
                    break;
                }
              }
            },
          });

          //doc.save("altasAfiliados.pdf");
          window.open(doc.output("bloburl"));
        } else {
          const doc = new jsPDF.default(0, 0);
          doc.setFontSize(10);
          if (tipo === "0") {
            doc.text(
              `Subdiario Iva Compras agrupado por ${grupo.nombre} Desde: ${vigencia.desde} Hasta: ${vigencia.hasta}`,
              30,
              8
            );
          } else {
            doc.text(
              `Listado de Compras agrupado por ${grupo.nombre} Desde: ${vigencia.desde} Hasta: ${vigencia.hasta}`,
              30,
              8
            );
          }
          doc.autoTable(exportColumnsAgrupado, listadoExcel, {
            styles: {
              fontSize: 6,
            },
            columnStyles: {
              1: {
                halign: "right",
              },
              2: {
                halign: "right",
              },
              3: {
                halign: "right",
              },
              4: {
                halign: "right",
              },
              5: {
                halign: "right",
              },
              6: {
                halign: "right",
              },
              7: {
                halign: "right",
              },
              8: {
                halign: "right",
              },
              9: {
                halign: "right",
              },
              10: {
                halign: "right",
              },
              11: {
                halign: "right",
              },
              12: {
                halign: "right",
              },
              13: {
                halign: "right",
              },
              14: {
                halign: "right",
              },
              15: {
                halign: "right",
              },
              16: {
                halign: "right",
              },
            },
            didParseCell: (data) => {
              if (data.cell && data.cell.section === "head") {
                switch (data.cell.raw) {
                  case "Descripción":
                    data.cell.styles.halign = "left";
                    break;
                  default:
                    data.cell.styles.halign = "right";
                    break;
                }
              }
            },
          });
          window.open(doc.output("bloburl"));
          //doc.save("altasAfiliadosAgrupado.pdf");
        }
      });
    });
  };

  function formatDate(input) {
    var datePart = input.match(/\d+/g),
      year = datePart[0],
      month = datePart[1],
      day = datePart[2];
    return day + "/" + month + "/" + year;
  }

  function formatDateTime(dateString) {
    var allDate = dateString.replace("T", " ");
    allDate = allDate.replace(".", " ");
    allDate = allDate.split(" ");
    var thisDate = allDate[0].split("-");
    var thisTime = allDate[1].split(":");
    var newDate = [thisDate[2], thisDate[1], thisDate[0]].join("/");
    var newTime = [thisTime[0], thisTime[1]].join(":");
    return newDate + " " + newTime;
  }

  //console.log(listadoExcel);
  //console.log(serviciosFinalizadosExcel);

  return (
    <Fragment>
      <Menu />
      <Toast ref={toast} />
      {statusAcceso === 0 ? <Spinner /> : null}
      {statusAcceso === 400 ? accesoDenegado() : null}
      {statusAcceso === 200 ? (
        <Fragment>
          <Dialog
            header={renderHeaderFechas()}
            visible={visibleFechas}
            closable={false}
            footer={renderFooterFechas()}
            breakpoints={{ "960px": "75vw" }}
            style={{ width: "70vw", paddingBottom: "0" }}
            position="top"
          >
            <Grid container spacing={3} style={{ marginTop: "1vw" }}>
              <Grid item xs={12} md={4}>
                <label htmlFor="vigenciaDesde">Vigencia Desde</label>
                <InputMask
                  id="vigenciaDesde"
                  mask="99/99"
                  value={vigencia ? vigencia.desde : null}
                  placeholder="99/99"
                  //onBlur={handleEnter}
                  size={4}
                  onChange={(e) =>
                    guardarVigencia({
                      ...vigencia,
                      desde: e.value,
                    })
                  }
                  style={{ marginLeft: "0.7vw", marginTop: "0.4vw" }}
                ></InputMask>
              </Grid>

              <Grid item xs={12} md={4}>
                <label htmlFor="vigenciaHasta">Vigencia Hasta</label>
                <InputMask
                  id="vigenciaHasta"
                  mask="99/99"
                  value={vigencia ? vigencia.hasta : null}
                  placeholder="99/99"
                  //onBlur={handleEnter}
                  size={4}
                  onChange={(e) =>
                    guardarVigencia({
                      ...vigencia,
                      hasta: e.value,
                    })
                  }
                  style={{ marginLeft: "0.7vw", marginTop: "0.4vw" }}
                ></InputMask>
              </Grid>

              <Grid item xs={12} md={4} />

              <Grid
                item
                xs={12}
                md={5}
                style={{ marginLeftLeft: "1vw", marginTop: "0em" }}
              >
                <Autocomplete
                  id="agrupar"
                  fullWidth
                  options={agrupar}
                  disablePortal
                  getOptionLabel={(option) => option.nombre}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Agrupar por"
                      variant="standard"
                    />
                  )}
                  //onKeyDown={handleEnter}
                  onChange={(event, value) => {
                    if (value) {
                      setGrupo(value);
                    } else {
                      setGrupo(null);
                    }
                  }}
                />
              </Grid>
              {/*
              <Grid
                item
                xs={6}
                md={3}
                style={{ paddingLeft: "1vw", marginTop: "1vw" }}
              >
                <FormControlLabel
                  control={
                    <Checkbox
                      style={{ marginLeft: "1vw", marginRight: "1vw" }}
                      inputId="incluirAjustes"
                      onChange={(e) => {
                        setIncluirAjustes(e.target.checked);
                      }}
                      checked={incluirAjustes ? incluirAjustes : false}
                    />
                  }
                  label="Incluid Ajustes"
                />
              </Grid>
                */}
            </Grid>
          </Dialog>
        </Fragment>
      ) : null}
      <Grid item xs={12} sm={12}></Grid>
    </Fragment>
  );
}

/* class="MuiDataGrid-cell MuiDataGrid-cellLeft" */
